import React, { useState, useEffect } from 'react';
// import BottomNavigationVendor from "../BottomNavigationVendor/BottomNavigationVendor"
import BottomNavigationVendor from '../../../../Component/Vendors/BottomNavigationVendor/BottomNavigationVendor';
import axios from 'axios';
import { useNavigate } from "react-router-dom"
import CraneAcceptedOrders from './CraneAcceptedOrders';
import CraneRejectedOrder from './CraneRejectedOrder';
import CraneCompletedOrders from './CraneCompletedOrders';
import { useWebSocket } from '../../../../context/WebSocketContext';

import CraneSideBar from '../../../../Component/Customers/slidebar/CraneSideBar'
import icon11 from '../../../../Assets/crane/icon11.svg'
import icon12 from '../../../../Assets/crane/icon12.svg'
import icon13 from '../../../../Assets/crane/icon13.svg'
import icon14 from '../../../../Assets/crane/icon14.svg'
import icon15 from '../../../../Assets/crane/icon15.svg'
import icon16 from '../../../../Assets/crane/icon16.svg'
import search from '../../../../Assets/home2/search.svg'
import comingCrane from '../../../../Assets/comingCrane.png'


const btns = [
    { name: "Working", id: 1 },
    { name: "Rejected", id: 2 },
    { name: "Completed", id: 3 },
]

const CraneOrdersNew = () => {

    const navigate = useNavigate()
    const { messages } = useWebSocket()
    const [totalAssignedCases, setTotalAssignedCases] = useState([]);
    const [approvedCaseByYou, setApprovedCaseByYou] = useState([])
    const [rejectedByYou, setRejectedByYou] = useState([])
    const [rejectedByAdmin, setRejectedByAdmin] = useState([])
    const [rejectedByCustomer, setRejectedByCustomer] = useState([])
    const [completedVehicle, setCompletedVehicle] = useState([])
    const [recentlyCancelled, setRecentlyCancelled] = useState('')

    //console.log("compltedVehicler", completedVehicle)


    const [gotResponse, setGotResponse] = useState([]);
    const [distance, setDistances] = useState([])

    const [caseDetails, setCaseDetails] = useState(false);

    const [avg, setAvg] = useState([])
    const [vendorCurrentLatitude, setVendorCurrentLatitude] = useState("")
    const [vendorCurrentLongitude, setVendorCurrentLongitude] = useState("")

    const token = localStorage.getItem("token");
    const userId = localStorage.getItem("userId");

    useEffect(() => {
        if (messages.length > 0) {
            messages.forEach((message) => {
                console.log("message123 craneordrs new", message.message);
                if (message.forPage === "crane-user-all-cases") {
                    fetchAssignedCases();
                }
            });
        }
        else if (token === '' || userId === '') {
            navigate('/');
        }
        else if ((token !== '' && userId !== '') && navigate) {
            fetchAssignedCases();
        }
    }, [token, userId, navigate, messages]);


    const choosenCase = (item) => {
        setApprovedCaseByYou([])
        setApprovedCaseByYou([item])
        setCaseDetails(true)
    }

    const fetchAssignedCases = async () => {
        try {

            setLoading(true)

            // let apiDetail = userId.startsWith('VC-') ? 'assignedTasksCraneForVendor' : 'assignedTasksUnfiltered';
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/assignedTasksUnfiltered/${userId}/${userId}`, { headers: { Authorization: `Bearer ${token}` } });

            console.log('response', response);

            console.log("Total assignedTasksMechanic", response.data.data);
            setTotalAssignedCases(response.data.data);

            // Temporary arrays for each category
            const tempApprovedCaseByYou = [];
            const tempRejectedByYou = [];
            // const tempRejectedByAdmin = [];
            const tempRejectedByCustomer = [];
            const tempCompletedVehicle = [];
            //console.log('response.data.data', response.data.data)
            response.data.data.forEach((item) => {
                if (item.details.length > 0) {
                    //console.log('kjhkjhj', item.details[0])

                    if (item?.details[0]?.completeOrder === 0 && item.details[0]?.firstResponseOn != null && item.details[0]?.vendorDecision === 'accept' &&
                        item.details[0]?.cancelOrder === 0 && item.details[0]?.cancelPreAssignOrder === 0 && item.details[0]?.closeWorker === 0) {
                        tempApprovedCaseByYou.push(item);
                    }
                    if (item.details[0]?.vendorDecision === 'reject') {
                        tempRejectedByYou.push(item);
                    }
                    // if (item.details[0]?.vendorDecision === 'accept' && item.details[0]?.acceptedByAdmin === 'reject') {
                    //     tempRejectedByAdmin.push(item);
                    // }
                    if (
                        item.details[0].completeOrder === 0 && item.details[0]?.firstResponseOn != null && item.details[0]?.vendorDecision === 'accept' &&
                        (item.details[0]?.cancelPreAssignOrder || item.details[0]?.cancelOrder)
                    ) {
                        tempRejectedByCustomer.push(item);
                    }

                    if (item.details[0]?.approvedReaching === 1 && item.details[0].completeOrder === 1) {
                        tempCompletedVehicle.push(item);
                    }
                }
            });

            //console.log("tempApprovedCaseByYou", tempApprovedCaseByYou)
            //console.log("tempRejectedByYou", tempRejectedByYou)
            // console.log("tempRejectedByAdmin",tempRejectedByAdmin)
            //console.log("tempRejectedByCustomer", tempRejectedByCustomer)
            //console.log("tempCompletedVehicl1e", tempCompletedVehicle)
            tempRejectedByCustomer.map(item => {
                //console.log('item.cancelledAt', item.details[0].cancelledAt)
                const cancellationTime = new Date(item.details[0].cancelledAt);
                //console.log('cancellationTime', cancellationTime)
                const currentTime = new Date();
                //console.log('currentTime', currentTime)

                const timeDiff = (currentTime - cancellationTime) / (1000 * 60);
                //console.log('timediff', timeDiff)
                if (timeDiff < 2) {
                    //console.log('details[0].issue_occured', item.details[0].issue_occured)
                    setRecentlyCancelled(item.details[0].issue_occured);
                }

            })

            // Update state with collected results
            setApprovedCaseByYou(tempApprovedCaseByYou);
            setRejectedByYou(tempRejectedByYou);
            // setRejectedByAdmin(tempRejectedByAdmin);
            setRejectedByCustomer(tempRejectedByCustomer);
            setCompletedVehicle(tempCompletedVehicle);

            setLoading(false)

        } catch (error) {
            console.error("Failed to fetch assigned cases:", error);
            setLoading(false)
        }
    };

    const [selectedIndex, setSelectedIndex] = useState(0);
    const [selectedRejectedIndex, setSelectedRejectedIndex] = useState(0);

    const handleSelect = (index) => {
        setSelectedIndex(index);
    };

    const handleSelectRejectedIndex = (index) => {
        setSelectedRejectedIndex(index)
    }

    const [hBtn, setHBtn] = useState("Completed")

    const callButtonClick = (e) => {

        //console.log(e);
        setHBtn(e)
        let index = e === 'Complete Process' ? 0 : 1;
        console.log(index);
        handleSelect(index)

    }

    const [loading, setLoading] = useState(false);

    return (

        <>
            <div className='crane-section'>
                <h6 className="font-[700] text-center font-satoshi text-[61px] leading-[68px] text-[#FFFFFF] pt-[52px] mb-0 pb-[72px]">
                    Crane Service</h6>
                <div style={{ backdropFilter: "blur(20px)", height: "79px" }} className="flex bg-[#FFFFFF4D] max-w-[736px] w-full mx-auto py-[28px] rounded-[66px] pl-[40px] mb-[78px] pr-[28px] items-center justify-between">
                    <input type="text" className='outline-none bg-transparent text-[#FFFFFF] placeholder:text-[#FFFFFF] font-[500] text-[16px] leading-[20px]' placeholder='Search By Service' />
                    <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/home2/search.svg' style={{ height: "23px", width: "23px" }} alt="" />
                </div>

            </div>
            <div className='flex md:flex-row flex-col justify-center gap-[30px]'>
                <CraneSideBar />
                <div className='max-w-[979px] py-[38px] px-[40px] w-full bg-[#EFF9FD] border-[1px] border-[#E7E4FC] rounded-[12px]'>
                    <h6 className="font-[700] font-satoshi text-[30px] text-[#0A0119] m-0 pb-[30px]">History & Receipts</h6>
                    <div className="flex gap-[12px] pb-[26px]">
                        {btns?.map((e) => {
                            return (
                                <>
                                    <button key={e?.id} onClick={() => callButtonClick(e?.name)}
                                        className={`rounded-[92px] font-satoshi text-[16px] border-[1px] py-[14px] max-w-[202px] w-full ${hBtn === e?.name ? "bg-[#21A6E9] text-[#FFFFFF] border-[#E7E4FC] font-[700]" : "bg-[#FFFFFF] text-[#000000] border-[#E7E4FC] font-[400]"}`}>

                                        {e?.name}</button>
                                </>
                            )
                        })}
                    </div>

                    {hBtn === "Working" &&
                        <div className="grid md:grid-cols-2 grid-cols-1 gap-[23px] ">

                            {approvedCaseByYou.length === 0 && <div>No cases found!</div>}

                            {approvedCaseByYou?.map((item, dataIndex) => (

                                <div className="bg-[#FFFFFF] border-[1px] border-[#E7E4FC] py-[40px] px-[30px] rounded-[12px] ">
                                    <ol className="flex items-start gap-[3px] justify-between his-line max-w-[536px] pl-0 mb-0 mx-auto w-full">
                                        <li className='h-full w-[38px]' title={item?.details[0]?.connectedVendorFullyTime?.replace('T', ' | ').replace('.000Z', '')} >
                                            <div className="flex flex-col items-center gap-[6px]">
                                                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon12.svg' className='h-[38px] w-[38px]' alt="" />
                                                <p className="m-0 font-[500] font-satoshi text-[13px] text-[#21A6E9] text-center">Filled</p>
                                            </div>
                                        </li>
                                        <li className='w-[60px]' title={item?.details[0]?.customerAcceptedVendorTime?.replace('T', ' | ').replace('.000Z', '')}>
                                            <div className="flex flex-col items-center gap-[6px]">
                                                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon13.svg' className='h-[38px] w-[38px]' alt="" />
                                                <p className="m-0 font-[500] font-satoshi text-[13px] text-[#21A6E9] text-center">Vendor Assigned</p>
                                            </div>
                                        </li>
                                        <li className='w-[60px]' title={item?.details[0]?.vendorMovedTime?.replace('T', ' | ').replace('.000Z', '')}>
                                            <div className="flex flex-col items-center gap-[6px]">
                                                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon14.svg' className='h-[38px] w-[38px]' alt="" />
                                                <p className="m-0 font-[500] font-satoshi text-[13px] text-[#21A6E9] text-center">Accepted & Moved</p>
                                            </div>
                                        </li>
                                        <li className='w-[60px]' title={item?.details[0]?.vendorReachedTime?.replace('T', ' | ').replace('.000Z', '')}>
                                            <div className="flex flex-col items-center gap-[6px]">
                                                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon15.svg' className='h-[38px] w-[38px]' alt="" />
                                                <p className="m-0 font-[500] font-satoshi text-[13px] text-[#21A6E9] text-center">Reached</p>
                                            </div>
                                        </li>
                                        <li className='w-[60px]' title={item?.details[0]?.doneWorkingTime?.replace('T', ' | ').replace('.000Z', '')}>
                                            <div className="flex flex-col items-center gap-[6px]">
                                                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon16.svg' className='h-[38px] w-[38px]' alt="" />
                                                <p className="m-0 font-[500] font-satoshi text-[13px] text-[#21A6E9] text-center">Work Done</p>
                                            </div>
                                        </li>
                                    </ol>
                                    <div className="flex justify-center">
                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon11.svg' className='py-[28px]' alt="" />
                                    </div>
                                    <div className="grid sm:grid-cols-2 gap-[60px] gap-y-[20px]">
                                        <div>
                                            <h6 className="m-0 font-[700] font-satoshi text-[24px] text-[#0A0119] pb-[6px]">{item.details[0].reg}</h6>
                                            <p className="font-[500] m-0 font-satoshi text-[16px] text-[#515151]">Vehicle No</p>
                                        </div>
                                        <div>
                                            <h6 className="m-0 font-[700] font-satoshi text-[24px] text-[#0A0119] pb-[6px]">{item.details[0].systemDate?.split("|")[0].split("T")[0]}</h6>
                                            <p className="font-[500] m-0 font-satoshi text-[16px] text-[#515151]">Registered Date</p>
                                        </div>
                                        <div>
                                            <h6 className="m-0 font-[700] font-satoshi text-[24px] text-[#0A0119] pb-[6px]">NA</h6>
                                            <p className="font-[500] m-0 font-satoshi text-[16px] text-[#515151]">Vendor</p>
                                        </div>
                                        <div>
                                            <h6 className="m-0 font-[700] font-satoshi text-[24px] text-[#0A0119] pb-[6px]">Work Done</h6>
                                            <p className="font-[500] m-0 font-satoshi text-[16px] text-[#515151]">Current Status</p>
                                        </div>
                                    </div>
                                </div>

                            ))}
                        </div>
                    }

                    {hBtn === "Rejected" &&

                        <div className="grid md:grid-cols-2 grid-cols-1 gap-[23px] ">

                            {[...rejectedByYou, ...rejectedByCustomer].length === 0 && <div>No cases found!</div>}


                            {[...rejectedByYou, ...rejectedByCustomer]?.map((item, dataIndex) => (

                                <div className="bg-[#FFFFFF] border-[1px] border-[#E7E4FC] py-[40px] px-[30px] rounded-[12px] ">
                                    <ol className="flex items-start gap-[3px] justify-between his-line max-w-[536px] pl-0 mb-0 mx-auto w-full">
                                        <li className='h-full w-[38px]' title={item?.details[0]?.connectedVendorFullyTime?.replace('T', ' | ').replace('.000Z', '')} >
                                            <div className="flex flex-col items-center gap-[6px]">
                                                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon12.svg' className='h-[38px] w-[38px]' alt="" />
                                                <p className="m-0 font-[500] font-satoshi text-[13px] text-[#B1B1B1] text-center">Processing</p>
                                            </div>
                                        </li>
                                        <li className='w-[60px]' title={item?.details[0]?.customerAcceptedVendorTime?.replace('T', ' | ').replace('.000Z', '')}>
                                            <div className="flex flex-col items-center gap-[6px]">
                                                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon13.svg' className='h-[38px] w-[38px]' alt="" />
                                                <p className="m-0 font-[500] font-satoshi text-[13px] text-[#B1B1B1] text-center">Filled</p>
                                            </div>
                                        </li>
                                        <li className='w-[60px]' title={item?.details[0]?.vendorMovedTime?.replace('T', ' | ').replace('.000Z', '')}>
                                            <div className="flex flex-col items-center gap-[6px]">
                                                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon14.svg' className='h-[38px] w-[38px]' alt="" />
                                                <p className="m-0 font-[500] font-satoshi text-[13px] text-[#B1B1B1] text-center">Rejected</p>
                                            </div>
                                        </li>
                                        {/* <li className='w-[60px]' title={item?.details[0]?.vendorReachedTime?.replace('T', ' | ').replace('.000Z', '')}>
                                            <div className="flex flex-col items-center gap-[6px]">
                                                <img src={icon15} className='h-[38px] w-[38px]' alt="" />
                                                <p className="m-0 font-[500] font-satoshi text-[13px] text-[#B1B1B1] text-center">Reached</p>
                                            </div>
                                        </li> */}
                                        {/* <li className='w-[60px]' title={item?.details[0]?.doneWorkingTime?.replace('T', ' | ').replace('.000Z', '')}>
                                            <div className="flex flex-col items-center gap-[6px]">
                                                <img src={icon16} className='h-[38px] w-[38px]' alt="" />
                                                <p className="m-0 font-[500] font-satoshi text-[13px] text-[#B1B1B1] text-center">Work Done</p>
                                            </div>
                                        </li> */}
                                    </ol>
                                    <div className="flex justify-center">
                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon11.svg' className='py-[28px]' alt="" />
                                    </div>
                                    <div className="grid sm:grid-cols-2 gap-[60px] gap-y-[20px]">
                                        <div>
                                            <h6 className="m-0 font-[700] font-satoshi text-[24px] text-[#0A0119] pb-[6px]">{item.details[0].reg}</h6>
                                            <p className="font-[500] m-0 font-satoshi text-[16px] text-[#515151]">Vehicle No</p>
                                        </div>
                                        <div>
                                            <h6 className="m-0 font-[700] font-satoshi text-[24px] text-[#0A0119] pb-[6px]">{item.details[0].systemDate?.split("|")[0].split("T")[0]}</h6>
                                            <p className="font-[500] m-0 font-satoshi text-[16px] text-[#515151]">Registered Date</p>
                                        </div>
                                        <div>
                                            <h6 className="m-0 font-[700] font-satoshi text-[24px] text-[#0A0119] pb-[6px]">NA</h6>
                                            <p className="font-[500] m-0 font-satoshi text-[16px] text-[#515151]">Vendor</p>
                                        </div>
                                        <div>
                                            <h6 className="m-0 font-[700] font-satoshi text-[24px] text-[#0A0119] pb-[6px]">Rejected</h6>
                                            <p className="font-[500] m-0 font-satoshi text-[16px] text-[#515151]">Current Status</p>
                                        </div>
                                    </div>
                                </div>

                            ))}
                        </div>
                    }

                    {hBtn === "Completed" &&
                        <div className="grid md:grid-cols-2 grid-cols-1 gap-[23px] ">

                            {loading && <div > <span
                                class="spinner-border spinner-border-sm me-1" ></span> Loading..</div>}

                            {completedVehicle.length === 0 && <div>No cases found!</div>}


                            {completedVehicle?.map((item, dataIndex) => (

                                <div className="bg-[#FFFFFF] border-[1px] border-[#E7E4FC] py-[40px] px-[30px] rounded-[12px] ">
                                    <ol className="flex items-start gap-[3px] justify-between his-line max-w-[536px] pl-0 mb-0 mx-auto w-full">
                                        <li className='h-full w-[38px]' title={item?.details[0]?.connectedVendorFullyTime?.replace('T', ' | ').replace('.000Z', '')} >
                                            <div className="flex flex-col items-center gap-[6px]">
                                                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon12.svg' className='h-[38px] w-[38px]' alt="" />
                                                <p className="m-0 font-[500] font-satoshi text-[13px] text-[#21A6E9] text-center">Filled</p>
                                            </div>
                                        </li>
                                        <li className='w-[60px]' title={item?.details[0]?.customerAcceptedVendorTime?.replace('T', ' | ').replace('.000Z', '')}>
                                            <div className="flex flex-col items-center gap-[6px]">
                                                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon13.svg' className='h-[38px] w-[38px]' alt="" />
                                                <p className="m-0 font-[500] font-satoshi text-[13px] text-[#21A6E9] text-center">Vendor Assigned</p>
                                            </div>
                                        </li>
                                        <li className='w-[60px]' title={item?.details[0]?.vendorMovedTime?.replace('T', ' | ').replace('.000Z', '')}>
                                            <div className="flex flex-col items-center gap-[6px]">
                                                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon14.svg' className='h-[38px] w-[38px]' alt="" />
                                                <p className="m-0 font-[500] font-satoshi text-[13px] text-[#21A6E9] text-center">Accepted & Moved</p>
                                            </div>
                                        </li>
                                        <li className='w-[60px]' title={item?.details[0]?.vendorReachedTime?.replace('T', ' | ').replace('.000Z', '')}>
                                            <div className="flex flex-col items-center gap-[6px]">
                                                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon15.svg' className='h-[38px] w-[38px]' alt="" />
                                                <p className="m-0 font-[500] font-satoshi text-[13px] text-[#21A6E9] text-center">Reached</p>
                                            </div>
                                        </li>
                                        <li className='w-[60px]' title={item?.details[0]?.doneWorkingTime?.replace('T', ' | ').replace('.000Z', '')}>
                                            <div className="flex flex-col items-center gap-[6px]">
                                                <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon16.svg' className='h-[38px] w-[38px]' alt="" />
                                                <p className="m-0 font-[500] font-satoshi text-[13px] text-[#21A6E9] text-center">Work Done</p>
                                            </div>
                                        </li>
                                    </ol>
                                    <div className="flex justify-center">
                                        <img src='https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/icon11.svg' className='py-[28px]' alt="" />
                                    </div>
                                    <div className="grid sm:grid-cols-2 gap-[60px] gap-y-[20px]">
                                        <div>
                                            <h6 className="m-0 font-[700] font-satoshi text-[24px] text-[#0A0119] pb-[6px]">{item.details[0].reg}</h6>
                                            <p className="font-[500] m-0 font-satoshi text-[16px] text-[#515151]">Vehicle No</p>
                                        </div>
                                        <div>
                                            <h6 className="m-0 font-[700] font-satoshi text-[24px] text-[#0A0119] pb-[6px]">{item.details[0].systemDate?.split("|")[0].split("T")[0]}</h6>
                                            <p className="font-[500] m-0 font-satoshi text-[16px] text-[#515151]">Registered Date</p>
                                        </div>
                                        <div>
                                            <h6 className="m-0 font-[700] font-satoshi text-[24px] text-[#0A0119] pb-[6px]">NA</h6>
                                            <p className="font-[500] m-0 font-satoshi text-[16px] text-[#515151]">Vendor</p>
                                        </div>
                                        <div>
                                            <h6 className="m-0 font-[700] font-satoshi text-[24px] text-[#0A0119] pb-[6px]">Work Done</h6>
                                            <p className="font-[500] m-0 font-satoshi text-[16px] text-[#515151]">Current Status</p>
                                        </div>
                                    </div>
                                </div>

                            ))}

                        </div>
                    }

                </div>
            </div>
        </>

    )
}

export default CraneOrdersNew
